<template>
  <Search v-model="currentVal"></Search>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import Search from '@/components/taskFilterBox/search'
export default {
  components: {
    Search
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapState('task/task', {
      keyword: state => state.queryMsg.keyword
    }),
    currentVal:{
      get() {
        return this.keyword
      },
      set(newVal) {
        this.set_keyword(newVal)
      }
    }
  },
  methods: {
    ...mapMutations('task/task', ['set_keyword']),
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.filter-search {
  display: flex;
  align-items: center;
  transition: all .3s;
  width: 24px;
  i {
    @include fontColorOpacity(.6);
  }
  .el-input__inner {
    border: 0 none !important;
    padding-left: 8px;
    &:hover, &:focus {
      border: 0 none !important;
    }
  }
}
</style>
